import PropTypes from "prop-types";
import React from "react";
import Button from "react-bootstrap/Button";
import { BasicLoader } from "ui/loader";
import { getErrorMessage } from "util/response";

class BulkDeviceEditSample extends React.PureComponent {
  static get propTypes() {
    return {
      addErrorMessage: PropTypes.func.isRequired,
      appParams: PropTypes.array,
      bulkCustomDownload: PropTypes.func.isRequired,
      bulkDownload: PropTypes.func.isRequired,
      flags: PropTypes.array,
      isCustomConfig: PropTypes.bool.isRequired,
      properties: PropTypes.array,
      targets: PropTypes.array,
    };
  }

  constructor() {
    super();

    this.state = {
      downloading: false,
    };

    this._startDownload = this._startDownload.bind(this);
  }

  _getBulkExportCsv() {
    const {
      addErrorMessage,
      appParams,
      bulkDownload,
      bulkCustomDownload,
      flags,
      isCustomConfig,
      properties,
      targets,
    } = this.props;
    const serviceArgs = {
      appParams,
      flags,
      properties,
      targets,
    };
    const promise = isCustomConfig
      ? bulkCustomDownload(serviceArgs)
      : bulkDownload();

    return promise
      .then((res) => {
        const { data = {} } = res.data;
        const { url } = data;
        if (url) {
          window.open(url, "_parent");
          return;
        }

        addErrorMessage("Unable to export devices config: No devices found.");
      })
      .catch((e) => {
        addErrorMessage(
          `Unable to export devices config: ${getErrorMessage(e)}`,
        );
      })
      .finally(() => {
        this.setState({ downloading: false });
      });
  }

  _startDownload() {
    this.setState({ downloading: true }, this._getBulkExportCsv);
  }

  _renderButtonText() {
    const { downloading } = this.state;

    return downloading ? (
      <BasicLoader>Exporting, please wait...</BasicLoader>
    ) : (
      <span>
        <i className="fa fa-download" />
        Export Devices Configuration as .csv
      </span>
    );
  }

  render() {
    const { downloading } = this.state;

    return (
      <Button
        className="btn-bulk-download"
        disabled={downloading}
        onClick={this._startDownload}
        variant="secondary"
      >
        {this._renderButtonText()}
      </Button>
    );
  }
}

export { BulkDeviceEditSample };
